import Box from '../Box'
import Text from '../Text'

interface Props {
  title?: string
  padding?: string
  isBackgroundVisible?: boolean
}

const PanelSection = ({ title = '', padding = '1rem', isBackgroundVisible = false }: Props) => (
  <Box backgroundColor={isBackgroundVisible ? 'gray3' : 'white'} padding={padding}>
    <Text fontWeight="bold" fontSize={16}>
      {title}
    </Text>
  </Box>
)

export default PanelSection
